import { useEffect, useState } from 'react';
import IconButton, { IconButtonProps } from '../IconButton/IconButton';
import { Wrapper } from './IconButtonOn.style';

export type IconButtonOnProps = {
  name: string;
  value: boolean;
  onChange: (value: boolean) => void;
} & Partial<IconButtonProps>;

export function IconButtonOn(props: IconButtonOnProps) {
  const [on, setOn] = useState(props.value);

  const color = on ? 'pink' : '#ffffff67';

  function toggle() {
    setOn(!on);
    props.onChange(!on);
  }

  useEffect(() => {
    setOn(props.value);
  }, [props.value]);

  return (
    <Wrapper className='IconButtonOn-wrapper' data-testid='IconButtonOn-wrapper'>
      <IconButton {...props} color={color} onClick={toggle} />
    </Wrapper>
  );
}

export default IconButtonOn;
